import { Component, Input } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { PayinDepositInstructions } from '../../utils/payin-link-result';

@Component({
  selector: 'app-payin-deposit-details',
  templateUrl: './payin-deposit-details.component.html',
  styleUrl: './payin-deposit-details.component.scss',
})
export class PayinDepositDetailsComponent {
  @Input() instructions: PayinDepositInstructions | null = null;
  @Input() isManualValidation = false;
  @Input() providerError = '';
  @Input() message = '';
  @Input() transactionId: string | number | null = null;

  constructor(public utilsService: UtilsService) {}

  get destination(): string {
    const info = this.instructions;
    if (!info) return '';
    return String(info.pix_key || info.account_number || info.account_alias || '').trim();
  }

  get isSpeiClabe(): boolean {
    const info = this.instructions;
    if (!info) return false;
    const accountType = String(info.account_type || '').toUpperCase();
    const bank = String(info.bank || '').toUpperCase();
    return accountType === 'CLABE' || bank === 'SPEI';
  }

  get destinationLabel(): string {
    if (this.isSpeiClabe) return 'CLABE';
    if (this.instructions?.pix_key) return 'PIX / cuenta destino';
    return 'Cuenta destino';
  }
}
